export default __webpack_public_path__ + "static/media/lpp.8be87ee3.png";